<template>
    <div class="ma-3 step-action">
        <v-toolbar>
            <v-toolbar-title>Select Payload</v-toolbar-title>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-list dense>
                    <v-subheader>Available Payloads</v-subheader>
                    <v-radio-group @change="handleActivePayloadChange"
                                   :loading="activePayloadLoading"
                                   :disabled="activePayloadLoading"
                                   :value="activePayloadId">
                    <template v-for="payloadDefinition in payloadDefinitions">
                        <v-list-tile
                                :key="payloadDefinition.id"
                                ripple
                        >
                            <v-list-tile-content>
                                <v-radio
                                        :label="`${payloadDefinition.name} v${payloadDefinition.version}`"
                                        :value="payloadDefinition.id"
                                ></v-radio>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                    </v-radio-group>
                </v-list>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "select-payload",
  computed: {
    ...mapState([
      "payloadDefinitions",
      "activePayload",
      "activePayloadLoading"
    ]),
    ...mapGetters(["getPayloadDefinitionById"]),
    activePayloadId() {
      return this.activePayload.definition
        ? this.activePayload.definition.id
        : null;
    }
  },
  methods: {
    handleActivePayloadChange(id) {
      //console.log(this.getPayloadDefinitionById(id));
      this.$store.dispatch(
        "loadActivePayload",
        this.getPayloadDefinitionById(id)
      );
    }
  }
};
</script>
